<template>
  <div id="HMOC">
    <div id="HMOC-top"></div>
    <div id="HMOC-body">
      <div class="HMOC-body-top">
        <div class="HMOC-title">
          <p class="HMOC-title-before"></p>
          <p class="HMOC-title-middle">儿童检测</p>
          <p class="HMOC-title-after"></p>
        </div>
        <div class="HMOC-content">
          <p>科学规划健康检查时间与项目，定期给孩子做健康检查可以随时了解孩子的生长发育和健康状况，早期发现孩子生长异常、身体缺陷和疾病，方便家长尽早采取相应措施进行干预。对0-7岁的儿童的体格检查进行规划：0-1岁，每年至少体检4次；1-3岁，每年至少体检2次；4-7岁，每年至少体检1次。各年龄段的儿童，除了基本常规项目的内外科检查、血常规、尿常规检测外、智力筛查、听力筛查、视力筛查之外，还建议进项辅助项目的检测，如血铅、微量元素检测、心理气质测定等。</p>
        </div>
        <div class="HMOC-title">
          <p class="HMOC-title-before"></p>
          <p class="HMOC-title-middle">儿童保健</p>
          <p class="HMOC-title-after"></p>
        </div>
        <div class="HMOC-content">
          <p>根据检测结果及儿童所处阶段，依据专业的育儿医师团队提供的儿童科学、早期干预(主要针对营养、睡眠、发育行为等)</p>
        </div>
      </div>
      <div class="HMOC-body-middle">
        <P class="body-title">功能模块</P>
        <div class="HMOC-body-middle-content">
          <div style="margin-right: 170px;">
            <img style="height:70px;margin-bottom: 12px;" src="../../assets/images/ProductAndService/HMOC/growth_curve.png"/>
            <p>成长曲线</p>
          </div>
          <div style="margin-right: 128px;">
            <img style="height:74px;margin-bottom: 10px;" src="../../assets/images/ProductAndService/HMOC/GrowthAndDevelopment.png"/>
            <p>成长发育</p>
          </div>
          <div  style="margin-right: 110px;">
            <img style="height:64px;margin-bottom: 16px;" src="../../assets/images/ProductAndService/HMOC/trace_record.png"/>
            <p>跟踪记录孕妇新生儿</p>
          </div>
          <div>
            <img style="height:74px;margin-bottom: 12px;" src="../../assets/images/ProductAndService/HMOC/Guide-record.png"/>
            <p>育儿保健干预指导</p>
          </div>
        </div>
      </div>
      <div class="HMOC-body-end">
        <p class="HMOC-body-end-title">适用单位</p>
        <p class="HMOC-body-end-content">儿童保健中心 | 幼儿园 | 妇幼保健院 | 儿童医院 | 综合医院及社会卫生服务中心 | 各乡镇卫生院等</p><p class="HMOC-body-end-title">适用科室</p>
        <p class="HMOC-body-end-content">儿科 | 营养门诊 | 营养科 | 儿童保健科等</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#HMOC-top{
  height: 600px;
  background-size: auto 100%;
  background-position:center;
  background-repeat: no-repeat;
  background-image: url(../../assets/images/ProductAndService/HMOC/HMOC_Banner.png);
}
#HMOC-body .HMOC-body-top{
  padding-top: 60px;
  padding-bottom: 60px;
}
#HMOC-body .HMOC-body-middle{
  background-color: #f9f9f9;
  padding-top: 60px;
  padding-bottom: 60px;
}
#HMOC-body .HMOC-body-middle .HMOC-body-middle-content{
  margin-top: 32px;
  text-align: center;
}
#HMOC-body .HMOC-body-middle .HMOC-body-middle-content div{
  display: inline-block;
}
#HMOC-body .HMOC-body-middle .HMOC-body-middle-content p{
  font-size: 20px;
  color: #909090;
}
#HMOC-body .HMOC-body-end{
  padding-top: 40px;
  padding-bottom: 60px;
}
#HMOC-body .HMOC-body-end .HMOC-body-end-title{
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #404040;
}
#HMOC-body .HMOC-body-end .HMOC-body-end-content{
  font-size: 16px;
  color: #909090;
}
#HMOC-body .body-title{
  font-size: 36px;
  color: #282828;
}
.HMOC-title{
  text-align: center;
  margin-bottom: 20px;
}
.HMOC-title .HMOC-title-middle {
  font-size: 24px;
  color: #282828;
  display: inline-block;
}
.HMOC-title .HMOC-title-before{
  width: 6px;
  height: 6px;
  display: inline-block;
  background-color: #000;
  -moz-border-radius: 3px;
  margin-bottom: 5px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}
.HMOC-title .HMOC-title-after{
  width: 6px;
  height: 6px;
  margin-bottom: 5px;
  display: inline-block;
  background-color: #000;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}
#HMOC-body .HMOC-content{
  text-align: center;
}
#HMOC-body .HMOC-content p{
  text-align: left;
  text-indent:2em;
  display: inline-block;
  width: 740px;
  line-height: 30px;
  font-size: 14px;
  color: #909090;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductAndService/HMOC.vue